import { GetFiltersQuery } from '../get-filters';

export function mockedFilters(
  input: GetFiltersQuery.Input,
): GetFiltersQuery.Output {
  const system = systems.find((s) => s.id === input.systemId);

  if (!system) {
    throw new Error(`System with id ${input.systemId} not found`);
  }

  const banks = system.banks;

  const packs = banks.flatMap(function (bank) {
    if (
      input.selectedFilters.bankId &&
      bank.id !== input.selectedFilters.bankId
    ) {
      return [];
    }

    return bank.packs;
  });

  return {
    filters: {
      bank: {
        id: 'bank',
        label: 'Bank',
        values: banks.map((bank) => ({
          id: bank.id,
          label: bank.fullFrontendId,
        })),
      },
      pack: {
        id: 'pack',
        label: 'Rack',
        values: packs.map((pack) => ({
          id: pack.id,
          label: pack.fullFrontendId,
        })),
      },
    },
  };
}

type Pack = {
  id: string;
  fullFrontendId: string;
};

type Bank = {
  id: string;
  fullFrontendId: string;
  packs: Pack[];
};

type System = {
  id: string;
  fullFrontendId: string;
  banks: Bank[];
};

const systems: System[] = [
  {
    id: '12345',
    fullFrontendId: 'Country_Corner',
    banks: [
      {
        id: '9739835394366000',
        fullFrontendId: 'Country_Corner/B01',
        packs: [
          {
            id: '18510550128694977',
            fullFrontendId: 'Country_Corner/B01/Rack_01',
          },
          {
            id: '20549422368304181',
            fullFrontendId: 'Country_Corner/B01/Rack_02',
          },
          {
            id: '67208029915131260',
            fullFrontendId: 'Country_Corner/B01/Rack_03',
          },
          {
            id: '27545060227891593',
            fullFrontendId: 'Country_Corner/B01/Rack_04',
          },
          {
            id: '60601306731649707',
            fullFrontendId: 'Country_Corner/B01/Rack_05',
          },
          {
            id: '63123832139559368',
            fullFrontendId: 'Country_Corner/B01/Rack_06',
          },
          {
            id: '41944926425762964',
            fullFrontendId: 'Country_Corner/B01/Rack_07',
          },
          {
            id: '24405506703844224',
            fullFrontendId: 'Country_Corner/B01/Rack_08',
          },
          {
            id: '42272127689711786',
            fullFrontendId: 'Country_Corner/B01/Rack_09',
          },
          {
            id: '6471416015895949',
            fullFrontendId: 'Country_Corner/B01/Rack_10',
          },
        ],
      },
      {
        id: '14115102612756205',
        fullFrontendId: 'Country_Corner/B02',
        packs: [
          {
            id: '53412654243085819',
            fullFrontendId: 'Country_Corner/B02/Rack_01',
          },
          {
            id: '41132362186614864',
            fullFrontendId: 'Country_Corner/B02/Rack_02',
          },
          {
            id: '200804506794335',
            fullFrontendId: 'Country_Corner/B02/Rack_03',
          },
          {
            id: '3005189968530496',
            fullFrontendId: 'Country_Corner/B02/Rack_04',
          },
          {
            id: '22183080308027674',
            fullFrontendId: 'Country_Corner/B02/Rack_05',
          },
          {
            id: '33153032122014401',
            fullFrontendId: 'Country_Corner/B02/Rack_06',
          },
          {
            id: '11384857325292251',
            fullFrontendId: 'Country_Corner/B02/Rack_07',
          },
          {
            id: '53702617871982399',
            fullFrontendId: 'Country_Corner/B02/Rack_08',
          },
          {
            id: '43313190410857714',
            fullFrontendId: 'Country_Corner/B02/Rack_09',
          },
          {
            id: '49587895811009218',
            fullFrontendId: 'Country_Corner/B02/Rack_10',
          },
        ],
      },
      {
        id: '65852267895348562',
        fullFrontendId: 'Country_Corner/B03',
        packs: [
          {
            id: '49243845264996471',
            fullFrontendId: 'Country_Corner/B03/Rack_01',
          },
          {
            id: '47799741924237567',
            fullFrontendId: 'Country_Corner/B03/Rack_02',
          },
          {
            id: '19546148844086505',
            fullFrontendId: 'Country_Corner/B03/Rack_03',
          },
          {
            id: '12413274228929202',
            fullFrontendId: 'Country_Corner/B03/Rack_04',
          },
          {
            id: '10193385709592867',
            fullFrontendId: 'Country_Corner/B03/Rack_05',
          },
          {
            id: '27325543801546025',
            fullFrontendId: 'Country_Corner/B03/Rack_06',
          },
          {
            id: '25491175176508835',
            fullFrontendId: 'Country_Corner/B03/Rack_07',
          },
          {
            id: '50385604783138722',
            fullFrontendId: 'Country_Corner/B03/Rack_08',
          },
          {
            id: '33421511769530802',
            fullFrontendId: 'Country_Corner/B03/Rack_09',
          },
          {
            id: '29970670436018244',
            fullFrontendId: 'Country_Corner/B03/Rack_10',
          },
        ],
      },
      {
        id: '32524247218213010',
        fullFrontendId: 'Country_Corner/B04',
        packs: [
          {
            id: '11057815505330630',
            fullFrontendId: 'Country_Corner/B04/Rack_01',
          },
          {
            id: '9964012301718093',
            fullFrontendId: 'Country_Corner/B04/Rack_02',
          },
          {
            id: '68692154953849428',
            fullFrontendId: 'Country_Corner/B04/Rack_03',
          },
          {
            id: '27864213323333659',
            fullFrontendId: 'Country_Corner/B04/Rack_04',
          },
          {
            id: '2251106242537921',
            fullFrontendId: 'Country_Corner/B04/Rack_05',
          },
          {
            id: '42230967664824705',
            fullFrontendId: 'Country_Corner/B04/Rack_06',
          },
          {
            id: '32398600054135596',
            fullFrontendId: 'Country_Corner/B04/Rack_07',
          },
          {
            id: '32228836347571270',
            fullFrontendId: 'Country_Corner/B04/Rack_08',
          },
          {
            id: '43743256505231184',
            fullFrontendId: 'Country_Corner/B04/Rack_09',
          },
          {
            id: '50371792209163583',
            fullFrontendId: 'Country_Corner/B04/Rack_10',
          },
        ],
      },
      {
        id: '15142662163423298',
        fullFrontendId: 'Country_Corner/B05',
        packs: [
          {
            id: '25873446975477286',
            fullFrontendId: 'Country_Corner/B05/Rack_01',
          },
          {
            id: '15324756511501699',
            fullFrontendId: 'Country_Corner/B05/Rack_02',
          },
          {
            id: '12842385906561425',
            fullFrontendId: 'Country_Corner/B05/Rack_03',
          },
          {
            id: '6754493798219001',
            fullFrontendId: 'Country_Corner/B05/Rack_04',
          },
          {
            id: '46986623740661229',
            fullFrontendId: 'Country_Corner/B05/Rack_05',
          },
          {
            id: '34451422262265380',
            fullFrontendId: 'Country_Corner/B05/Rack_06',
          },
          {
            id: '51228206435257463',
            fullFrontendId: 'Country_Corner/B05/Rack_07',
          },
          {
            id: '60935478022470524',
            fullFrontendId: 'Country_Corner/B05/Rack_08',
          },
          {
            id: '47899254095945171',
            fullFrontendId: 'Country_Corner/B05/Rack_09',
          },
          {
            id: '41766947065356657',
            fullFrontendId: 'Country_Corner/B05/Rack_10',
          },
        ],
      },
      {
        id: '18544298069061869',
        fullFrontendId: 'Country_Corner/B06',
        packs: [
          {
            id: '5989054454777011',
            fullFrontendId: 'Country_Corner/B06/Rack_01',
          },
          {
            id: '61595418260241589',
            fullFrontendId: 'Country_Corner/B06/Rack_02',
          },
          {
            id: '31987574562642903',
            fullFrontendId: 'Country_Corner/B06/Rack_03',
          },
          {
            id: '12499268189333681',
            fullFrontendId: 'Country_Corner/B06/Rack_04',
          },
          {
            id: '34272712166528836',
            fullFrontendId: 'Country_Corner/B06/Rack_05',
          },
          {
            id: '53228867100884859',
            fullFrontendId: 'Country_Corner/B06/Rack_06',
          },
          {
            id: '52439835487991639',
            fullFrontendId: 'Country_Corner/B06/Rack_07',
          },
          {
            id: '52458105774515491',
            fullFrontendId: 'Country_Corner/B06/Rack_08',
          },
          {
            id: '15939649511646368',
            fullFrontendId: 'Country_Corner/B06/Rack_09',
          },
          {
            id: '18133567724010800',
            fullFrontendId: 'Country_Corner/B06/Rack_10',
          },
        ],
      },
      {
        id: '66868980844720849',
        fullFrontendId: 'Country_Corner/B07',
        packs: [
          {
            id: '9989473834664962',
            fullFrontendId: 'Country_Corner/B07/Rack_01',
          },
          {
            id: '69618346777589466',
            fullFrontendId: 'Country_Corner/B07/Rack_02',
          },
          {
            id: '14128602983920693',
            fullFrontendId: 'Country_Corner/B07/Rack_03',
          },
          {
            id: '32892454087772485',
            fullFrontendId: 'Country_Corner/B07/Rack_04',
          },
          {
            id: '63377333619320009',
            fullFrontendId: 'Country_Corner/B07/Rack_05',
          },
          {
            id: '35260018520653022',
            fullFrontendId: 'Country_Corner/B07/Rack_06',
          },
          {
            id: '3665309423788960',
            fullFrontendId: 'Country_Corner/B07/Rack_07',
          },
          {
            id: '15352581004808595',
            fullFrontendId: 'Country_Corner/B07/Rack_08',
          },
          {
            id: '35916998317933242',
            fullFrontendId: 'Country_Corner/B07/Rack_09',
          },
          {
            id: '32872391906993377',
            fullFrontendId: 'Country_Corner/B07/Rack_10',
          },
        ],
      },
      {
        id: '47756555087370039',
        fullFrontendId: 'Country_Corner/B08',
        packs: [
          {
            id: '64544906727223905',
            fullFrontendId: 'Country_Corner/B08/Rack_01',
          },
          {
            id: '23152343014322097',
            fullFrontendId: 'Country_Corner/B08/Rack_02',
          },
          {
            id: '3509739286086225',
            fullFrontendId: 'Country_Corner/B08/Rack_03',
          },
          {
            id: '13317774037895696',
            fullFrontendId: 'Country_Corner/B08/Rack_04',
          },
          {
            id: '57506560893055939',
            fullFrontendId: 'Country_Corner/B08/Rack_05',
          },
          {
            id: '54611592107022391',
            fullFrontendId: 'Country_Corner/B08/Rack_06',
          },
          {
            id: '68194431705816823',
            fullFrontendId: 'Country_Corner/B08/Rack_07',
          },
          {
            id: '65342725437198548',
            fullFrontendId: 'Country_Corner/B08/Rack_08',
          },
          {
            id: '8973983127750483',
            fullFrontendId: 'Country_Corner/B08/Rack_09',
          },
          {
            id: '9163541306821944',
            fullFrontendId: 'Country_Corner/B08/Rack_10',
          },
        ],
      },
      {
        id: '48132666588666541',
        fullFrontendId: 'Country_Corner/B09',
        packs: [
          {
            id: '61004656969650268',
            fullFrontendId: 'Country_Corner/B09/Rack_01',
          },
          {
            id: '32584793640122762',
            fullFrontendId: 'Country_Corner/B09/Rack_02',
          },
          {
            id: '59449140925314565',
            fullFrontendId: 'Country_Corner/B09/Rack_03',
          },
          {
            id: '68920896432152338',
            fullFrontendId: 'Country_Corner/B09/Rack_04',
          },
          {
            id: '46790268423753599',
            fullFrontendId: 'Country_Corner/B09/Rack_05',
          },
          {
            id: '37874475004350576',
            fullFrontendId: 'Country_Corner/B09/Rack_06',
          },
          {
            id: '2958847841157008',
            fullFrontendId: 'Country_Corner/B09/Rack_07',
          },
          {
            id: '26350145115484613',
            fullFrontendId: 'Country_Corner/B09/Rack_08',
          },
          {
            id: '32718999393037227',
            fullFrontendId: 'Country_Corner/B09/Rack_09',
          },
          {
            id: '50677494698974635',
            fullFrontendId: 'Country_Corner/B09/Rack_10',
          },
        ],
      },
      {
        id: '17871600849759120',
        fullFrontendId: 'Country_Corner/B10',
        packs: [
          {
            id: '785503921293096',
            fullFrontendId: 'Country_Corner/B10/Rack_01',
          },
          {
            id: '24203669966234050',
            fullFrontendId: 'Country_Corner/B10/Rack_02',
          },
          {
            id: '25429773579953858',
            fullFrontendId: 'Country_Corner/B10/Rack_03',
          },
          {
            id: '32656801140191935',
            fullFrontendId: 'Country_Corner/B10/Rack_04',
          },
          {
            id: '33086645431136950',
            fullFrontendId: 'Country_Corner/B10/Rack_05',
          },
          {
            id: '44821244190917697',
            fullFrontendId: 'Country_Corner/B10/Rack_06',
          },
          {
            id: '15751082509800804',
            fullFrontendId: 'Country_Corner/B10/Rack_07',
          },
          {
            id: '14178622165374584',
            fullFrontendId: 'Country_Corner/B10/Rack_08',
          },
          {
            id: '17881726359928172',
            fullFrontendId: 'Country_Corner/B10/Rack_09',
          },
          {
            id: '32809988975118168',
            fullFrontendId: 'Country_Corner/B10/Rack_10',
          },
        ],
      },
      {
        id: '56724886883381766',
        fullFrontendId: 'Country_Corner/B11',
        packs: [
          {
            id: '23323314879478550',
            fullFrontendId: 'Country_Corner/B11/Rack_01',
          },
          {
            id: '61365916912849309',
            fullFrontendId: 'Country_Corner/B11/Rack_02',
          },
          {
            id: '23468523451455008',
            fullFrontendId: 'Country_Corner/B11/Rack_03',
          },
          {
            id: '829221139101683',
            fullFrontendId: 'Country_Corner/B11/Rack_04',
          },
          {
            id: '8614138290846856',
            fullFrontendId: 'Country_Corner/B11/Rack_05',
          },
          {
            id: '48818031772887542',
            fullFrontendId: 'Country_Corner/B11/Rack_06',
          },
          {
            id: '20465382959444694',
            fullFrontendId: 'Country_Corner/B11/Rack_07',
          },
          {
            id: '7332170133676183',
            fullFrontendId: 'Country_Corner/B11/Rack_08',
          },
          {
            id: '67551768505398407',
            fullFrontendId: 'Country_Corner/B11/Rack_09',
          },
          {
            id: '21073265830312646',
            fullFrontendId: 'Country_Corner/B11/Rack_10',
          },
        ],
      },
      {
        id: '23128282883536391',
        fullFrontendId: 'Country_Corner/B12',
        packs: [
          {
            id: '18012315565896238',
            fullFrontendId: 'Country_Corner/B12/Rack_01',
          },
          {
            id: '4096745221330263',
            fullFrontendId: 'Country_Corner/B12/Rack_02',
          },
          {
            id: '14939940098146335',
            fullFrontendId: 'Country_Corner/B12/Rack_03',
          },
          {
            id: '43096600658243782',
            fullFrontendId: 'Country_Corner/B12/Rack_04',
          },
          {
            id: '46968088649331818',
            fullFrontendId: 'Country_Corner/B12/Rack_05',
          },
          {
            id: '6056484481157065',
            fullFrontendId: 'Country_Corner/B12/Rack_06',
          },
          {
            id: '5593354097500761',
            fullFrontendId: 'Country_Corner/B12/Rack_07',
          },
          {
            id: '11827113576427829',
            fullFrontendId: 'Country_Corner/B12/Rack_08',
          },
          {
            id: '69727619634080034',
            fullFrontendId: 'Country_Corner/B12/Rack_09',
          },
          {
            id: '15219950701611155',
            fullFrontendId: 'Country_Corner/B12/Rack_10',
          },
        ],
      },
      {
        id: '69536875005703131',
        fullFrontendId: 'Country_Corner/B13',
        packs: [
          {
            id: '46452454989978560',
            fullFrontendId: 'Country_Corner/B13/Rack_01',
          },
          {
            id: '69006296838680225',
            fullFrontendId: 'Country_Corner/B13/Rack_02',
          },
          {
            id: '63998850703293741',
            fullFrontendId: 'Country_Corner/B13/Rack_03',
          },
          {
            id: '46949240297145001',
            fullFrontendId: 'Country_Corner/B13/Rack_04',
          },
          {
            id: '399911267441666',
            fullFrontendId: 'Country_Corner/B13/Rack_05',
          },
          {
            id: '48619095513868517',
            fullFrontendId: 'Country_Corner/B13/Rack_06',
          },
          {
            id: '34768599284165404',
            fullFrontendId: 'Country_Corner/B13/Rack_07',
          },
          {
            id: '56653590783418914',
            fullFrontendId: 'Country_Corner/B13/Rack_08',
          },
          {
            id: '69842489705839361',
            fullFrontendId: 'Country_Corner/B13/Rack_09',
          },
          {
            id: '57550393130509657',
            fullFrontendId: 'Country_Corner/B13/Rack_10',
          },
        ],
      },
      {
        id: '41441766571723748',
        fullFrontendId: 'Country_Corner/B14',
        packs: [
          {
            id: '45297514382031054',
            fullFrontendId: 'Country_Corner/B14/Rack_01',
          },
          {
            id: '62503218827957649',
            fullFrontendId: 'Country_Corner/B14/Rack_02',
          },
          {
            id: '29245221879371902',
            fullFrontendId: 'Country_Corner/B14/Rack_03',
          },
          {
            id: '2050947959828042',
            fullFrontendId: 'Country_Corner/B14/Rack_04',
          },
          {
            id: '67770605905027679',
            fullFrontendId: 'Country_Corner/B14/Rack_05',
          },
          {
            id: '25632963672790656',
            fullFrontendId: 'Country_Corner/B14/Rack_06',
          },
          {
            id: '25111777456411057',
            fullFrontendId: 'Country_Corner/B14/Rack_07',
          },
          {
            id: '776486031583367',
            fullFrontendId: 'Country_Corner/B14/Rack_08',
          },
          {
            id: '9185293464686176',
            fullFrontendId: 'Country_Corner/B14/Rack_09',
          },
          {
            id: '20307605857058898',
            fullFrontendId: 'Country_Corner/B14/Rack_10',
          },
        ],
      },
      {
        id: '60754690120106369',
        fullFrontendId: 'Country_Corner/B15',
        packs: [
          {
            id: '53051536248505854',
            fullFrontendId: 'Country_Corner/B15/Rack_01',
          },
          {
            id: '16613706757810192',
            fullFrontendId: 'Country_Corner/B15/Rack_02',
          },
          {
            id: '62620663632847641',
            fullFrontendId: 'Country_Corner/B15/Rack_03',
          },
          {
            id: '10689697607974890',
            fullFrontendId: 'Country_Corner/B15/Rack_04',
          },
          {
            id: '55330563590153514',
            fullFrontendId: 'Country_Corner/B15/Rack_05',
          },
          {
            id: '9700019772627367',
            fullFrontendId: 'Country_Corner/B15/Rack_06',
          },
          {
            id: '70032675825587218',
            fullFrontendId: 'Country_Corner/B15/Rack_07',
          },
          {
            id: '2116836727674663',
            fullFrontendId: 'Country_Corner/B15/Rack_08',
          },
          {
            id: '18915650254211359',
            fullFrontendId: 'Country_Corner/B15/Rack_09',
          },
          {
            id: '64661473704722937',
            fullFrontendId: 'Country_Corner/B15/Rack_10',
          },
        ],
      },
      {
        id: '9542469758485020',
        fullFrontendId: 'Country_Corner/B16',
        packs: [
          {
            id: '49108634764414873',
            fullFrontendId: 'Country_Corner/B16/Rack_01',
          },
          {
            id: '35889711615253138',
            fullFrontendId: 'Country_Corner/B16/Rack_02',
          },
          {
            id: '12413331974127915',
            fullFrontendId: 'Country_Corner/B16/Rack_03',
          },
          {
            id: '67830636093593716',
            fullFrontendId: 'Country_Corner/B16/Rack_04',
          },
          {
            id: '18592466168668586',
            fullFrontendId: 'Country_Corner/B16/Rack_05',
          },
          {
            id: '17858253888497353',
            fullFrontendId: 'Country_Corner/B16/Rack_06',
          },
          {
            id: '71012265472545572',
            fullFrontendId: 'Country_Corner/B16/Rack_07',
          },
          {
            id: '14465267306586943',
            fullFrontendId: 'Country_Corner/B16/Rack_08',
          },
          {
            id: '30706446729201059',
            fullFrontendId: 'Country_Corner/B16/Rack_09',
          },
          {
            id: '4820068605217853',
            fullFrontendId: 'Country_Corner/B16/Rack_10',
          },
        ],
      },
      {
        id: '15656191718307884',
        fullFrontendId: 'Country_Corner/B17',
        packs: [
          {
            id: '52142253395025605',
            fullFrontendId: 'Country_Corner/B17/Rack_01',
          },
          {
            id: '20333699900798398',
            fullFrontendId: 'Country_Corner/B17/Rack_02',
          },
          {
            id: '61698682213406551',
            fullFrontendId: 'Country_Corner/B17/Rack_03',
          },
          {
            id: '22258116000080408',
            fullFrontendId: 'Country_Corner/B17/Rack_04',
          },
          {
            id: '2687068079496498',
            fullFrontendId: 'Country_Corner/B17/Rack_05',
          },
          {
            id: '4090001669242293',
            fullFrontendId: 'Country_Corner/B17/Rack_06',
          },
          {
            id: '21750137908642234',
            fullFrontendId: 'Country_Corner/B17/Rack_07',
          },
          {
            id: '7497721837416599',
            fullFrontendId: 'Country_Corner/B17/Rack_08',
          },
          {
            id: '67536427088638350',
            fullFrontendId: 'Country_Corner/B17/Rack_09',
          },
          {
            id: '56988802654745276',
            fullFrontendId: 'Country_Corner/B17/Rack_10',
          },
        ],
      },
      {
        id: '62043061842966335',
        fullFrontendId: 'Country_Corner/B18',
        packs: [
          {
            id: '70853358094367588',
            fullFrontendId: 'Country_Corner/B18/Rack_01',
          },
          {
            id: '22159651839929015',
            fullFrontendId: 'Country_Corner/B18/Rack_02',
          },
          {
            id: '61807720426445642',
            fullFrontendId: 'Country_Corner/B18/Rack_03',
          },
          {
            id: '41149068504866849',
            fullFrontendId: 'Country_Corner/B18/Rack_04',
          },
          {
            id: '35872618282645831',
            fullFrontendId: 'Country_Corner/B18/Rack_05',
          },
          {
            id: '37450924689339264',
            fullFrontendId: 'Country_Corner/B18/Rack_06',
          },
          {
            id: '57970417146406091',
            fullFrontendId: 'Country_Corner/B18/Rack_07',
          },
          {
            id: '56908883118135827',
            fullFrontendId: 'Country_Corner/B18/Rack_08',
          },
          {
            id: '66615624213342415',
            fullFrontendId: 'Country_Corner/B18/Rack_09',
          },
          {
            id: '65081736682430764',
            fullFrontendId: 'Country_Corner/B18/Rack_10',
          },
        ],
      },
      {
        id: '1166578162839735',
        fullFrontendId: 'Country_Corner/B19',
        packs: [
          {
            id: '41016897833360183',
            fullFrontendId: 'Country_Corner/B19/Rack_01',
          },
          {
            id: '59330341324369333',
            fullFrontendId: 'Country_Corner/B19/Rack_02',
          },
          {
            id: '40970096715439578',
            fullFrontendId: 'Country_Corner/B19/Rack_03',
          },
          {
            id: '41922314307811273',
            fullFrontendId: 'Country_Corner/B19/Rack_04',
          },
          {
            id: '2026255838254836',
            fullFrontendId: 'Country_Corner/B19/Rack_05',
          },
          {
            id: '51865357333988480',
            fullFrontendId: 'Country_Corner/B19/Rack_06',
          },
          {
            id: '6277603696836004',
            fullFrontendId: 'Country_Corner/B19/Rack_07',
          },
          {
            id: '39160585113044302',
            fullFrontendId: 'Country_Corner/B19/Rack_08',
          },
          {
            id: '15525746307216519',
            fullFrontendId: 'Country_Corner/B19/Rack_09',
          },
          {
            id: '13750238921869415',
            fullFrontendId: 'Country_Corner/B19/Rack_10',
          },
        ],
      },
      {
        id: '65952089403350033',
        fullFrontendId: 'Country_Corner/B20',
        packs: [
          {
            id: '573834764319158',
            fullFrontendId: 'Country_Corner/B20/Rack_01',
          },
          {
            id: '15649704207484200',
            fullFrontendId: 'Country_Corner/B20/Rack_02',
          },
          {
            id: '66087345753916469',
            fullFrontendId: 'Country_Corner/B20/Rack_03',
          },
          {
            id: '34937527639391239',
            fullFrontendId: 'Country_Corner/B20/Rack_04',
          },
          {
            id: '17562350934547220',
            fullFrontendId: 'Country_Corner/B20/Rack_05',
          },
          {
            id: '20795102937643068',
            fullFrontendId: 'Country_Corner/B20/Rack_06',
          },
          {
            id: '1625159942916716',
            fullFrontendId: 'Country_Corner/B20/Rack_07',
          },
          {
            id: '29545554138899483',
            fullFrontendId: 'Country_Corner/B20/Rack_08',
          },
          {
            id: '35814042208166959',
            fullFrontendId: 'Country_Corner/B20/Rack_09',
          },
          {
            id: '51261903590874457',
            fullFrontendId: 'Country_Corner/B20/Rack_10',
          },
        ],
      },
      {
        id: '56779848687839874',
        fullFrontendId: 'Country_Corner/B21',
        packs: [
          {
            id: '52187848566817573',
            fullFrontendId: 'Country_Corner/B21/Rack_01',
          },
          {
            id: '27170204668173644',
            fullFrontendId: 'Country_Corner/B21/Rack_02',
          },
          {
            id: '6204771740522162',
            fullFrontendId: 'Country_Corner/B21/Rack_03',
          },
          {
            id: '20906450787144733',
            fullFrontendId: 'Country_Corner/B21/Rack_04',
          },
          {
            id: '56701931486759686',
            fullFrontendId: 'Country_Corner/B21/Rack_05',
          },
          {
            id: '39562889667935613',
            fullFrontendId: 'Country_Corner/B21/Rack_06',
          },
          {
            id: '53494161462184094',
            fullFrontendId: 'Country_Corner/B21/Rack_07',
          },
          {
            id: '34966689709591649',
            fullFrontendId: 'Country_Corner/B21/Rack_08',
          },
          {
            id: '31046135398117221',
            fullFrontendId: 'Country_Corner/B21/Rack_09',
          },
          {
            id: '39957277760540041',
            fullFrontendId: 'Country_Corner/B21/Rack_10',
          },
        ],
      },
      {
        id: '6190551887328680',
        fullFrontendId: 'Country_Corner/B22',
        packs: [
          {
            id: '9183437896062067',
            fullFrontendId: 'Country_Corner/B22/Rack_01',
          },
          {
            id: '61750720480460367',
            fullFrontendId: 'Country_Corner/B22/Rack_02',
          },
          {
            id: '5009413002640889',
            fullFrontendId: 'Country_Corner/B22/Rack_03',
          },
          {
            id: '10439670912067822',
            fullFrontendId: 'Country_Corner/B22/Rack_04',
          },
          {
            id: '37633342627217530',
            fullFrontendId: 'Country_Corner/B22/Rack_05',
          },
          {
            id: '15652258410448933',
            fullFrontendId: 'Country_Corner/B22/Rack_06',
          },
          {
            id: '29853818218223332',
            fullFrontendId: 'Country_Corner/B22/Rack_07',
          },
          {
            id: '62893054815165414',
            fullFrontendId: 'Country_Corner/B22/Rack_08',
          },
          {
            id: '10163183405473968',
            fullFrontendId: 'Country_Corner/B22/Rack_09',
          },
          {
            id: '49400842981247887',
            fullFrontendId: 'Country_Corner/B22/Rack_10',
          },
        ],
      },
      {
        id: '28227970039726226',
        fullFrontendId: 'Country_Corner/B23',
        packs: [
          {
            id: '62550064869972480',
            fullFrontendId: 'Country_Corner/B23/Rack_01',
          },
          {
            id: '29724370716367113',
            fullFrontendId: 'Country_Corner/B23/Rack_02',
          },
          {
            id: '1610670103853015',
            fullFrontendId: 'Country_Corner/B23/Rack_03',
          },
          {
            id: '69369577755331986',
            fullFrontendId: 'Country_Corner/B23/Rack_04',
          },
          {
            id: '57639174054994672',
            fullFrontendId: 'Country_Corner/B23/Rack_05',
          },
          {
            id: '67365459092375554',
            fullFrontendId: 'Country_Corner/B23/Rack_06',
          },
          {
            id: '32689711467471291',
            fullFrontendId: 'Country_Corner/B23/Rack_07',
          },
          {
            id: '6978883631691550',
            fullFrontendId: 'Country_Corner/B23/Rack_08',
          },
          {
            id: '38305957045744950',
            fullFrontendId: 'Country_Corner/B23/Rack_09',
          },
          {
            id: '68114984296474538',
            fullFrontendId: 'Country_Corner/B23/Rack_10',
          },
        ],
      },
      {
        id: '25686743170497907',
        fullFrontendId: 'Country_Corner/B24',
        packs: [
          {
            id: '17201046990530016',
            fullFrontendId: 'Country_Corner/B24/Rack_01',
          },
          {
            id: '61434457278327309',
            fullFrontendId: 'Country_Corner/B24/Rack_02',
          },
          {
            id: '27400757141998347',
            fullFrontendId: 'Country_Corner/B24/Rack_03',
          },
          {
            id: '20110464637511486',
            fullFrontendId: 'Country_Corner/B24/Rack_04',
          },
          {
            id: '45041541419960412',
            fullFrontendId: 'Country_Corner/B24/Rack_05',
          },
          {
            id: '66839987110890160',
            fullFrontendId: 'Country_Corner/B24/Rack_06',
          },
          {
            id: '34546484587110454',
            fullFrontendId: 'Country_Corner/B24/Rack_07',
          },
          {
            id: '52855507319075531',
            fullFrontendId: 'Country_Corner/B24/Rack_08',
          },
          {
            id: '31085199199260777',
            fullFrontendId: 'Country_Corner/B24/Rack_09',
          },
          {
            id: '50712416082944508',
            fullFrontendId: 'Country_Corner/B24/Rack_10',
          },
        ],
      },
      {
        id: '57540051426467851',
        fullFrontendId: 'Country_Corner/B25',
        packs: [
          {
            id: '24504887961452069',
            fullFrontendId: 'Country_Corner/B25/Rack_01',
          },
          {
            id: '28117427348915420',
            fullFrontendId: 'Country_Corner/B25/Rack_02',
          },
          {
            id: '6958246851868558',
            fullFrontendId: 'Country_Corner/B25/Rack_03',
          },
          {
            id: '2954543959903114',
            fullFrontendId: 'Country_Corner/B25/Rack_04',
          },
          {
            id: '6540304199980755',
            fullFrontendId: 'Country_Corner/B25/Rack_05',
          },
          {
            id: '47665735283617424',
            fullFrontendId: 'Country_Corner/B25/Rack_06',
          },
          {
            id: '69095184924677916',
            fullFrontendId: 'Country_Corner/B25/Rack_07',
          },
          {
            id: '24121244713338821',
            fullFrontendId: 'Country_Corner/B25/Rack_08',
          },
          {
            id: '6429553694724504',
            fullFrontendId: 'Country_Corner/B25/Rack_09',
          },
          {
            id: '2435862662525847',
            fullFrontendId: 'Country_Corner/B25/Rack_10',
          },
        ],
      },
      {
        id: '25335588316095982',
        fullFrontendId: 'Country_Corner/B26',
        packs: [
          {
            id: '14581783459110500',
            fullFrontendId: 'Country_Corner/B26/Rack_01',
          },
          {
            id: '59395084066388735',
            fullFrontendId: 'Country_Corner/B26/Rack_02',
          },
          {
            id: '17852576880260495',
            fullFrontendId: 'Country_Corner/B26/Rack_03',
          },
          {
            id: '32790652432554140',
            fullFrontendId: 'Country_Corner/B26/Rack_04',
          },
          {
            id: '61659681451544347',
            fullFrontendId: 'Country_Corner/B26/Rack_05',
          },
          {
            id: '40969798542131576',
            fullFrontendId: 'Country_Corner/B26/Rack_06',
          },
          {
            id: '22596396457745528',
            fullFrontendId: 'Country_Corner/B26/Rack_07',
          },
          {
            id: '56079652480746013',
            fullFrontendId: 'Country_Corner/B26/Rack_08',
          },
          {
            id: '10010385498247626',
            fullFrontendId: 'Country_Corner/B26/Rack_09',
          },
          {
            id: '30388637531089197',
            fullFrontendId: 'Country_Corner/B26/Rack_10',
          },
        ],
      },
      {
        id: '67465371223031458',
        fullFrontendId: 'Country_Corner/B27',
        packs: [
          {
            id: '67656174610726294',
            fullFrontendId: 'Country_Corner/B27/Rack_01',
          },
          {
            id: '4061514289691207',
            fullFrontendId: 'Country_Corner/B27/Rack_02',
          },
          {
            id: '36354892003688144',
            fullFrontendId: 'Country_Corner/B27/Rack_03',
          },
          {
            id: '32471773617279006',
            fullFrontendId: 'Country_Corner/B27/Rack_04',
          },
          {
            id: '28545074712574921',
            fullFrontendId: 'Country_Corner/B27/Rack_05',
          },
          {
            id: '53237918646524405',
            fullFrontendId: 'Country_Corner/B27/Rack_06',
          },
          {
            id: '48661999858345633',
            fullFrontendId: 'Country_Corner/B27/Rack_07',
          },
          {
            id: '35017299569429283',
            fullFrontendId: 'Country_Corner/B27/Rack_08',
          },
          {
            id: '70410253746328374',
            fullFrontendId: 'Country_Corner/B27/Rack_09',
          },
          {
            id: '46976829218980256',
            fullFrontendId: 'Country_Corner/B27/Rack_10',
          },
        ],
      },
      {
        id: '57935239604972820',
        fullFrontendId: 'Country_Corner/B28',
        packs: [
          {
            id: '15990764837004244',
            fullFrontendId: 'Country_Corner/B28/Rack_01',
          },
          {
            id: '43457394153082489',
            fullFrontendId: 'Country_Corner/B28/Rack_02',
          },
          {
            id: '13471351640558659',
            fullFrontendId: 'Country_Corner/B28/Rack_03',
          },
          {
            id: '43257018117311641',
            fullFrontendId: 'Country_Corner/B28/Rack_04',
          },
          {
            id: '44441210032859093',
            fullFrontendId: 'Country_Corner/B28/Rack_05',
          },
          {
            id: '56809198314856746',
            fullFrontendId: 'Country_Corner/B28/Rack_06',
          },
          {
            id: '52892527099087293',
            fullFrontendId: 'Country_Corner/B28/Rack_07',
          },
          {
            id: '1517276912271249',
            fullFrontendId: 'Country_Corner/B28/Rack_08',
          },
          {
            id: '642901347155358',
            fullFrontendId: 'Country_Corner/B28/Rack_09',
          },
          {
            id: '16728424670061118',
            fullFrontendId: 'Country_Corner/B28/Rack_10',
          },
        ],
      },
      {
        id: '26038036222907881',
        fullFrontendId: 'Country_Corner/B29',
        packs: [
          {
            id: '46434595840970237',
            fullFrontendId: 'Country_Corner/B29/Rack_01',
          },
          {
            id: '38611058194173256',
            fullFrontendId: 'Country_Corner/B29/Rack_02',
          },
          {
            id: '70046936809406829',
            fullFrontendId: 'Country_Corner/B29/Rack_03',
          },
          {
            id: '18076209839280849',
            fullFrontendId: 'Country_Corner/B29/Rack_04',
          },
          {
            id: '54733539380796709',
            fullFrontendId: 'Country_Corner/B29/Rack_05',
          },
          {
            id: '37167083848744828',
            fullFrontendId: 'Country_Corner/B29/Rack_06',
          },
          {
            id: '35197177310155977',
            fullFrontendId: 'Country_Corner/B29/Rack_07',
          },
          {
            id: '69588550128907886',
            fullFrontendId: 'Country_Corner/B29/Rack_08',
          },
          {
            id: '54987447907194742',
            fullFrontendId: 'Country_Corner/B29/Rack_09',
          },
          {
            id: '22959367894914781',
            fullFrontendId: 'Country_Corner/B29/Rack_10',
          },
        ],
      },
      {
        id: '37567530921115554',
        fullFrontendId: 'Country_Corner/B30',
        packs: [
          {
            id: '54426466015475921',
            fullFrontendId: 'Country_Corner/B30/Rack_01',
          },
          {
            id: '769405584894263',
            fullFrontendId: 'Country_Corner/B30/Rack_02',
          },
          {
            id: '44604054646835931',
            fullFrontendId: 'Country_Corner/B30/Rack_03',
          },
          {
            id: '12242169608091269',
            fullFrontendId: 'Country_Corner/B30/Rack_04',
          },
          {
            id: '60137551809065668',
            fullFrontendId: 'Country_Corner/B30/Rack_05',
          },
          {
            id: '49907290519630689',
            fullFrontendId: 'Country_Corner/B30/Rack_06',
          },
          {
            id: '39521135278296569',
            fullFrontendId: 'Country_Corner/B30/Rack_07',
          },
          {
            id: '45762990185226657',
            fullFrontendId: 'Country_Corner/B30/Rack_08',
          },
          {
            id: '40376310974477272',
            fullFrontendId: 'Country_Corner/B30/Rack_09',
          },
          {
            id: '11931954233655033',
            fullFrontendId: 'Country_Corner/B30/Rack_10',
          },
        ],
      },
      {
        id: '29520743539604972',
        fullFrontendId: 'Country_Corner/B31',
        packs: [
          {
            id: '3516879690624759',
            fullFrontendId: 'Country_Corner/B31/Rack_01',
          },
          {
            id: '36314423494654061',
            fullFrontendId: 'Country_Corner/B31/Rack_02',
          },
          {
            id: '23741111991284011',
            fullFrontendId: 'Country_Corner/B31/Rack_03',
          },
          {
            id: '36562173920921604',
            fullFrontendId: 'Country_Corner/B31/Rack_04',
          },
          {
            id: '20595154266960448',
            fullFrontendId: 'Country_Corner/B31/Rack_05',
          },
          {
            id: '42577330539636526',
            fullFrontendId: 'Country_Corner/B31/Rack_06',
          },
          {
            id: '13713968915224737',
            fullFrontendId: 'Country_Corner/B31/Rack_07',
          },
          {
            id: '27927971759830067',
            fullFrontendId: 'Country_Corner/B31/Rack_08',
          },
          {
            id: '52491862310218294',
            fullFrontendId: 'Country_Corner/B31/Rack_09',
          },
          {
            id: '35059889886841900',
            fullFrontendId: 'Country_Corner/B31/Rack_10',
          },
        ],
      },
    ],
  },
  {
    id: '23456',
    fullFrontendId: 'Sunset_Plaza',
    banks: [
      {
        id: '30718404103119905',
        fullFrontendId: 'Sunset_Plaza/B01',
        packs: [
          {
            id: '26399089582606173',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_01',
          },
          {
            id: '29892652693419017',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_02',
          },
          {
            id: '8071063064781045',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_03',
          },
          {
            id: '30536073459127365',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_04',
          },
          {
            id: '14651119336651764',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_05',
          },
          {
            id: '55003725799344180',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_06',
          },
          {
            id: '4406298077844020',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_07',
          },
          {
            id: '21952001816093525',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_08',
          },
          {
            id: '15883090059378757',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_09',
          },
          {
            id: '48859838166449169',
            fullFrontendId: 'Sunset_Plaza/B01/Rack_10',
          },
        ],
      },
      {
        id: '20132512127652605',
        fullFrontendId: 'Sunset_Plaza/B02',
        packs: [
          {
            id: '66985951008464725',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_01',
          },
          {
            id: '57701079077095301',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_02',
          },
          {
            id: '49970749899411749',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_03',
          },
          {
            id: '31996901325983508',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_04',
          },
          {
            id: '53306554842481717',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_05',
          },
          {
            id: '55433806799781076',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_06',
          },
          {
            id: '6926079169698965',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_07',
          },
          {
            id: '31318829001449501',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_08',
          },
          {
            id: '19444488488967228',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_09',
          },
          {
            id: '40334473103058485',
            fullFrontendId: 'Sunset_Plaza/B02/Rack_10',
          },
        ],
      },
      {
        id: '26375145252243301',
        fullFrontendId: 'Sunset_Plaza/B03',
        packs: [
          {
            id: '15871244988651301',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_01',
          },
          {
            id: '41648725069481980',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_02',
          },
          {
            id: '40157962334924564',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_03',
          },
          {
            id: '10037318325925812',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_04',
          },
          {
            id: '69502419847506829',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_05',
          },
          {
            id: '21092100459418700',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_06',
          },
          {
            id: '31570436994326469',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_07',
          },
          {
            id: '53306969936456220',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_08',
          },
          {
            id: '8001455458055229',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_09',
          },
          {
            id: '1037373095423148',
            fullFrontendId: 'Sunset_Plaza/B03/Rack_10',
          },
        ],
      },
      {
        id: '40744635163444372',
        fullFrontendId: 'Sunset_Plaza/B04',
        packs: [
          {
            id: '24570806127773332',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_01',
          },
          {
            id: '15568892001730596',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_02',
          },
          {
            id: '18434449968325740',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_03',
          },
          {
            id: '59781993963139396',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_04',
          },
          {
            id: '42540518533388652',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_05',
          },
          {
            id: '8449765166093092',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_06',
          },
          {
            id: '42688700728729468',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_07',
          },
          {
            id: '24508998442325756',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_08',
          },
          {
            id: '41772388464962092',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_09',
          },
          {
            id: '62076698095133637',
            fullFrontendId: 'Sunset_Plaza/B04/Rack_10',
          },
        ],
      },
      {
        id: '47538560548968574',
        fullFrontendId: 'Sunset_Plaza/B05',
        packs: [
          {
            id: '44068516063830588',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_01',
          },
          {
            id: '67100003092847188',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_02',
          },
          {
            id: '55431844264139316',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_03',
          },
          {
            id: '68847436013799717',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_04',
          },
          {
            id: '21414823458577461',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_05',
          },
          {
            id: '50906953774080004',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_06',
          },
          {
            id: '46993866761756324',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_07',
          },
          {
            id: '59103651799493380',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_08',
          },
          {
            id: '52081624037709637',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_09',
          },
          {
            id: '34423444406854236',
            fullFrontendId: 'Sunset_Plaza/B05/Rack_10',
          },
        ],
      },
      {
        id: '31073992737191951',
        fullFrontendId: 'Sunset_Plaza/B06',
        packs: [
          {
            id: '19651734570847428',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_01',
          },
          {
            id: '69354096092244900',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_02',
          },
          {
            id: '48845962055522324',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_03',
          },
          {
            id: '4959756616096604',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_04',
          },
          {
            id: '36625436624493260',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_05',
          },
          {
            id: '48978203089854820',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_06',
          },
          {
            id: '60354970066970660',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_07',
          },
          {
            id: '42978945764159396',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_08',
          },
          {
            id: '18999733533444764',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_09',
          },
          {
            id: '58074242994831900',
            fullFrontendId: 'Sunset_Plaza/B06/Rack_10',
          },
        ],
      },
      {
        id: '5646263683372337',
        fullFrontendId: 'Sunset_Plaza/B07',
        packs: [
          {
            id: '52354329264725868',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_01',
          },
          {
            id: '32651414896093100',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_02',
          },
          {
            id: '30079729399659548',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_03',
          },
          {
            id: '55003639468090724',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_04',
          },
          {
            id: '13449043616764044',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_05',
          },
          {
            id: '12893633012709124',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_06',
          },
          {
            id: '60468623097348084',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_07',
          },
          {
            id: '26152623628374541',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_08',
          },
          {
            id: '66071424883725876',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_09',
          },
          {
            id: '69871037036829124',
            fullFrontendId: 'Sunset_Plaza/B07/Rack_10',
          },
        ],
      },
      {
        id: '25095599520628136',
        fullFrontendId: 'Sunset_Plaza/B08',
        packs: [
          {
            id: '21725397742336165',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_01',
          },
          {
            id: '51406079009447525',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_02',
          },
          {
            id: '34070623655088613',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_03',
          },
          {
            id: '23265825893582805',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_04',
          },
          {
            id: '69491624966430709',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_05',
          },
          {
            id: '70019533549154325',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_06',
          },
          {
            id: '9593424073738436',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_07',
          },
          {
            id: '35999734067988164',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_08',
          },
          {
            id: '52647113896925909',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_09',
          },
          {
            id: '46456616326424580',
            fullFrontendId: 'Sunset_Plaza/B08/Rack_10',
          },
        ],
      },
      {
        id: '1869295039075929',
        fullFrontendId: 'Sunset_Plaza/B09',
        packs: [
          {
            id: '58062459825966372',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_01',
          },
          {
            id: '33654070344344996',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_02',
          },
          {
            id: '31434062264425620',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_03',
          },
          {
            id: '36695055073799484',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_04',
          },
          {
            id: '30113152998749933',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_05',
          },
          {
            id: '49014397549962004',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_06',
          },
          {
            id: '29624059093633044',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_07',
          },
          {
            id: '30020050983983524',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_08',
          },
          {
            id: '64100013433667620',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_09',
          },
          {
            id: '69648949628773204',
            fullFrontendId: 'Sunset_Plaza/B09/Rack_10',
          },
        ],
      },
      {
        id: '7188901685439760',
        fullFrontendId: 'Sunset_Plaza/B10',
        packs: [
          {
            id: '67334076077549324',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_01',
          },
          {
            id: '47074993509779637',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_02',
          },
          {
            id: '31326436265635444',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_03',
          },
          {
            id: '45088738069966820',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_04',
          },
          {
            id: '30169700847616133',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_05',
          },
          {
            id: '22395050966690965',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_06',
          },
          {
            id: '52726398623721924',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_07',
          },
          {
            id: '21554726901705429',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_08',
          },
          {
            id: '23476444616088037',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_09',
          },
          {
            id: '31434651831773596',
            fullFrontendId: 'Sunset_Plaza/B10/Rack_10',
          },
        ],
      },
      {
        id: '37587440701671119',
        fullFrontendId: 'Sunset_Plaza/B11',
        packs: [
          {
            id: '47516953031113957',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_01',
          },
          {
            id: '39419648688926756',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_02',
          },
          {
            id: '22734493635963637',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_03',
          },
          {
            id: '16013652618439244',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_04',
          },
          {
            id: '38508088969945157',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_05',
          },
          {
            id: '38647063264079924',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_06',
          },
          {
            id: '48847061516962324',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_07',
          },
          {
            id: '35199607516962556',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_08',
          },
          {
            id: '48866949508488700',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_09',
          },
          {
            id: '31413645079074509',
            fullFrontendId: 'Sunset_Plaza/B11/Rack_10',
          },
        ],
      },
      {
        id: '31646670405234952',
        fullFrontendId: 'Sunset_Plaza/B12',
        packs: [
          {
            id: '19325394658766884',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_01',
          },
          {
            id: '50924430079677221',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_02',
          },
          {
            id: '64896754632479772',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_03',
          },
          {
            id: '23652896739324532',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_04',
          },
          {
            id: '64969659536624652',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_05',
          },
          {
            id: '67834793699459117',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_06',
          },
          {
            id: '36369953994668661',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_07',
          },
          {
            id: '52369554799426004',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_08',
          },
          {
            id: '68366958479965956',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_09',
          },
          {
            id: '31943659968494804',
            fullFrontendId: 'Sunset_Plaza/B12/Rack_10',
          },
        ],
      },
      {
        id: '63112088927389728',
        fullFrontendId: 'Sunset_Plaza/B13',
        packs: [
          {
            id: '50396854979974868',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_01',
          },
          {
            id: '69396965997339564',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_02',
          },
          {
            id: '38796659699795956',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_03',
          },
          {
            id: '46979655936965828',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_04',
          },
          {
            id: '38696559499725604',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_05',
          },
          {
            id: '67896559932468724',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_06',
          },
          {
            id: '39655993499629556',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_07',
          },
          {
            id: '50396559999946724',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_08',
          },
          {
            id: '38965593996929604',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_09',
          },
          {
            id: '49856599324668556',
            fullFrontendId: 'Sunset_Plaza/B13/Rack_10',
          },
        ],
      },
      {
        id: '71598940471247509',
        fullFrontendId: 'Sunset_Plaza/B14',
        packs: [
          {
            id: '69859654998665724',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_01',
          },
          {
            id: '50369659493299604',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_02',
          },
          {
            id: '39659593946592940',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_03',
          },
          {
            id: '68959659936965564',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_04',
          },
          {
            id: '49659593994628676',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_05',
          },
          {
            id: '59659959326689556',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_06',
          },
          {
            id: '39659593299469604',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_07',
          },
          {
            id: '68959659399266964',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_08',
          },
          {
            id: '49659593946592900',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_09',
          },
          {
            id: '59659599329466844',
            fullFrontendId: 'Sunset_Plaza/B14/Rack_10',
          },
        ],
      },
      {
        id: '30419150012822155',
        fullFrontendId: 'Sunset_Plaza/B15',
        packs: [
          {
            id: '58659693996469564',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_01',
          },
          {
            id: '49659593946692940',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_02',
          },
          {
            id: '68959659936965664',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_03',
          },
          {
            id: '39659593994668676',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_04',
          },
          {
            id: '59659959326689756',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_05',
          },
          {
            id: '39659593299469704',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_06',
          },
          {
            id: '68959659399267064',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_07',
          },
          {
            id: '49659593946593000',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_08',
          },
          {
            id: '59659599329466944',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_09',
          },
          {
            id: '38659693996469804',
            fullFrontendId: 'Sunset_Plaza/B15/Rack_10',
          },
        ],
      },
      {
        id: '44704272828581916',
        fullFrontendId: 'Sunset_Plaza/B16',
        packs: [
          {
            id: '48659693996469964',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_01',
          },
          {
            id: '39659593946693040',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_02',
          },
          {
            id: '68959659936965764',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_03',
          },
          {
            id: '49659593994668776',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_04',
          },
          {
            id: '59659959326689856',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_05',
          },
          {
            id: '39659593299469804',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_06',
          },
          {
            id: '68959659399267164',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_07',
          },
          {
            id: '49659593946593100',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_08',
          },
          {
            id: '59659599329467044',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_09',
          },
          {
            id: '48659693996469904',
            fullFrontendId: 'Sunset_Plaza/B16/Rack_10',
          },
        ],
      },
      {
        id: '58234417308923101',
        fullFrontendId: 'Sunset_Plaza/B17',
        packs: [
          {
            id: '58659693996470064',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_01',
          },
          {
            id: '49659593946693140',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_02',
          },
          {
            id: '68959659936965864',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_03',
          },
          {
            id: '39659593994668876',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_04',
          },
          {
            id: '59659959326689956',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_05',
          },
          {
            id: '39659593299469904',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_06',
          },
          {
            id: '68959659399267264',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_07',
          },
          {
            id: '49659593946593200',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_08',
          },
          {
            id: '59659599329467144',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_09',
          },
          {
            id: '58659693996470004',
            fullFrontendId: 'Sunset_Plaza/B17/Rack_10',
          },
        ],
      },
      {
        id: '71738629612187595',
        fullFrontendId: 'Sunset_Plaza/B18',
        packs: [
          {
            id: '68659693996470164',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_01',
          },
          {
            id: '39659593946693240',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_02',
          },
          {
            id: '68959659936965964',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_03',
          },
          {
            id: '49659593994668976',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_04',
          },
          {
            id: '59659959326690056',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_05',
          },
          {
            id: '39659593299470004',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_06',
          },
          {
            id: '68959659399267364',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_07',
          },
          {
            id: '49659593946593300',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_08',
          },
          {
            id: '59659599329467244',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_09',
          },
          {
            id: '68659693996470104',
            fullFrontendId: 'Sunset_Plaza/B18/Rack_10',
          },
        ],
      },
      {
        id: '35411598728802570',
        fullFrontendId: 'Sunset_Plaza/B19',
        packs: [
          {
            id: '78659693996470264',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_01',
          },
          {
            id: '49659593946693340',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_02',
          },
          {
            id: '68959659936966064',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_03',
          },
          {
            id: '39659593994669076',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_04',
          },
          {
            id: '59659959326690156',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_05',
          },
          {
            id: '39659593299470104',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_06',
          },
          {
            id: '68959659399267464',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_07',
          },
          {
            id: '49659593946593400',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_08',
          },
          {
            id: '59659599329467344',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_09',
          },
          {
            id: '78659693996470204',
            fullFrontendId: 'Sunset_Plaza/B19/Rack_10',
          },
        ],
      },
    ],
  },
  {
    id: '34567',
    fullFrontendId: 'Smart_Hill',
    banks: [
      {
        id: '68810249463363542',
        fullFrontendId: 'Smart_Hill/B01',
        packs: [
          {
            id: '44262786570105247',
            fullFrontendId: 'Smart_Hill/B01/Rack_01',
          },
          {
            id: '26905524237387724',
            fullFrontendId: 'Smart_Hill/B01/Rack_02',
          },
          {
            id: '43266919750272151',
            fullFrontendId: 'Smart_Hill/B01/Rack_03',
          },
          {
            id: '59086561782369494',
            fullFrontendId: 'Smart_Hill/B01/Rack_04',
          },
          {
            id: '4655539236530224',
            fullFrontendId: 'Smart_Hill/B01/Rack_05',
          },
          {
            id: '66684427417835148',
            fullFrontendId: 'Smart_Hill/B01/Rack_06',
          },
          {
            id: '44378986949131962',
            fullFrontendId: 'Smart_Hill/B01/Rack_07',
          },
        ],
      },
      {
        id: '26688779656110660',
        fullFrontendId: 'Smart_Hill/B02',
        packs: [
          {
            id: '6235619112861210',
            fullFrontendId: 'Smart_Hill/B02/Rack_01',
          },
          {
            id: '32005371243043353',
            fullFrontendId: 'Smart_Hill/B02/Rack_02',
          },
          {
            id: '65123223871815290',
            fullFrontendId: 'Smart_Hill/B02/Rack_03',
          },
          {
            id: '18568289531407894',
            fullFrontendId: 'Smart_Hill/B02/Rack_04',
          },
          {
            id: '7094469504664286',
            fullFrontendId: 'Smart_Hill/B02/Rack_05',
          },
          {
            id: '36078247376804333',
            fullFrontendId: 'Smart_Hill/B02/Rack_06',
          },
          {
            id: '36209438535110631',
            fullFrontendId: 'Smart_Hill/B02/Rack_07',
          },
        ],
      },
      {
        id: '5208048146371065',
        fullFrontendId: 'Smart_Hill/B03',
        packs: [
          {
            id: '35318091892249771',
            fullFrontendId: 'Smart_Hill/B03/Rack_01',
          },
          {
            id: '14107409534745415',
            fullFrontendId: 'Smart_Hill/B03/Rack_02',
          },
          {
            id: '49734039780099825',
            fullFrontendId: 'Smart_Hill/B03/Rack_03',
          },
          {
            id: '41650961282610639',
            fullFrontendId: 'Smart_Hill/B03/Rack_04',
          },
          {
            id: '62762969003009503',
            fullFrontendId: 'Smart_Hill/B03/Rack_05',
          },
          {
            id: '41265578664303445',
            fullFrontendId: 'Smart_Hill/B03/Rack_06',
          },
          {
            id: '52000826579640257',
            fullFrontendId: 'Smart_Hill/B03/Rack_07',
          },
        ],
      },
      {
        id: '52095245272996909',
        fullFrontendId: 'Smart_Hill/B04',
        packs: [
          {
            id: '38659240387588959',
            fullFrontendId: 'Smart_Hill/B04/Rack_01',
          },
          {
            id: '31333048061248156',
            fullFrontendId: 'Smart_Hill/B04/Rack_02',
          },
          {
            id: '49447700021204043',
            fullFrontendId: 'Smart_Hill/B04/Rack_03',
          },
          {
            id: '17141526905007658',
            fullFrontendId: 'Smart_Hill/B04/Rack_04',
          },
          {
            id: '32434374897784146',
            fullFrontendId: 'Smart_Hill/B04/Rack_05',
          },
          {
            id: '24277162998605119',
            fullFrontendId: 'Smart_Hill/B04/Rack_06',
          },
          {
            id: '47209317785957315',
            fullFrontendId: 'Smart_Hill/B04/Rack_07',
          },
        ],
      },
      {
        id: '62951201805066422',
        fullFrontendId: 'Smart_Hill/B05',
        packs: [
          {
            id: '61939568820839264',
            fullFrontendId: 'Smart_Hill/B05/Rack_01',
          },
          {
            id: '47907067275323195',
            fullFrontendId: 'Smart_Hill/B05/Rack_02',
          },
          {
            id: '48526863698603864',
            fullFrontendId: 'Smart_Hill/B05/Rack_03',
          },
          {
            id: '25250069974272448',
            fullFrontendId: 'Smart_Hill/B05/Rack_04',
          },
          {
            id: '5856479230073424',
            fullFrontendId: 'Smart_Hill/B05/Rack_05',
          },
          {
            id: '20471540913518535',
            fullFrontendId: 'Smart_Hill/B05/Rack_06',
          },
          {
            id: '50603710744382028',
            fullFrontendId: 'Smart_Hill/B05/Rack_07',
          },
        ],
      },
      {
        id: '42935953921198998',
        fullFrontendId: 'Smart_Hill/B06',
        packs: [
          {
            id: '21633242953326513',
            fullFrontendId: 'Smart_Hill/B06/Rack_01',
          },
          {
            id: '63716930169321346',
            fullFrontendId: 'Smart_Hill/B06/Rack_02',
          },
          {
            id: '4337717586297350',
            fullFrontendId: 'Smart_Hill/B06/Rack_03',
          },
          {
            id: '1816065337026227',
            fullFrontendId: 'Smart_Hill/B06/Rack_04',
          },
          {
            id: '23078986167548976',
            fullFrontendId: 'Smart_Hill/B06/Rack_05',
          },
          {
            id: '37061098950414129',
            fullFrontendId: 'Smart_Hill/B06/Rack_06',
          },
          {
            id: '46039135135769811',
            fullFrontendId: 'Smart_Hill/B06/Rack_07',
          },
        ],
      },
      {
        id: '54380859669690804',
        fullFrontendId: 'Smart_Hill/B07',
        packs: [
          {
            id: '56395827885335761',
            fullFrontendId: 'Smart_Hill/B07/Rack_01',
          },
          {
            id: '68288132438534195',
            fullFrontendId: 'Smart_Hill/B07/Rack_02',
          },
          {
            id: '42520939806310753',
            fullFrontendId: 'Smart_Hill/B07/Rack_03',
          },
          {
            id: '14659260481768716',
            fullFrontendId: 'Smart_Hill/B07/Rack_04',
          },
          {
            id: '9308028791642601',
            fullFrontendId: 'Smart_Hill/B07/Rack_05',
          },
          {
            id: '42580670235822364',
            fullFrontendId: 'Smart_Hill/B07/Rack_06',
          },
          {
            id: '7037076435548809',
            fullFrontendId: 'Smart_Hill/B07/Rack_07',
          },
        ],
      },
      {
        id: '55999870768132519',
        fullFrontendId: 'Smart_Hill/B08',
        packs: [
          {
            id: '2538918863590415',
            fullFrontendId: 'Smart_Hill/B08/Rack_01',
          },
          {
            id: '36828021029146421',
            fullFrontendId: 'Smart_Hill/B08/Rack_02',
          },
          {
            id: '51461022411741932',
            fullFrontendId: 'Smart_Hill/B08/Rack_03',
          },
          {
            id: '62334855922460872',
            fullFrontendId: 'Smart_Hill/B08/Rack_04',
          },
          {
            id: '25139187188403141',
            fullFrontendId: 'Smart_Hill/B08/Rack_05',
          },
          {
            id: '59702983162494328',
            fullFrontendId: 'Smart_Hill/B08/Rack_06',
          },
          {
            id: '25492131571971810',
            fullFrontendId: 'Smart_Hill/B08/Rack_07',
          },
        ],
      },
      {
        id: '17590262253897322',
        fullFrontendId: 'Smart_Hill/B09',
        packs: [
          {
            id: '7768783131568285',
            fullFrontendId: 'Smart_Hill/B09/Rack_01',
          },
          {
            id: '25163592552586681',
            fullFrontendId: 'Smart_Hill/B09/Rack_02',
          },
          {
            id: '26613609825343367',
            fullFrontendId: 'Smart_Hill/B09/Rack_03',
          },
          {
            id: '28253986343896803',
            fullFrontendId: 'Smart_Hill/B09/Rack_04',
          },
          {
            id: '31090759195636136',
            fullFrontendId: 'Smart_Hill/B09/Rack_05',
          },
          {
            id: '67340213169365601',
            fullFrontendId: 'Smart_Hill/B09/Rack_06',
          },
        ],
      },
      {
        id: '51937854157168776',
        fullFrontendId: 'Smart_Hill/B10',
        packs: [
          {
            id: '11158484892686668',
            fullFrontendId: 'Smart_Hill/B10/Rack_01',
          },
          {
            id: '68927473038752950',
            fullFrontendId: 'Smart_Hill/B10/Rack_02',
          },
          {
            id: '50436436145897532',
            fullFrontendId: 'Smart_Hill/B10/Rack_03',
          },
          {
            id: '39820713219009219',
            fullFrontendId: 'Smart_Hill/B10/Rack_04',
          },
          {
            id: '49339515477753697',
            fullFrontendId: 'Smart_Hill/B10/Rack_05',
          },
          {
            id: '28724523743614418',
            fullFrontendId: 'Smart_Hill/B10/Rack_06',
          },
        ],
      },
      {
        id: '90998129563161',
        fullFrontendId: 'Smart_Hill/B11',
        packs: [
          {
            id: '13376914750853058',
            fullFrontendId: 'Smart_Hill/B11/Rack_01',
          },
          {
            id: '56841109492578227',
            fullFrontendId: 'Smart_Hill/B11/Rack_02',
          },
          {
            id: '10946992763985964',
            fullFrontendId: 'Smart_Hill/B11/Rack_03',
          },
          {
            id: '35323450106053539',
            fullFrontendId: 'Smart_Hill/B11/Rack_04',
          },
          {
            id: '3521236114852592',
            fullFrontendId: 'Smart_Hill/B11/Rack_05',
          },
          {
            id: '13008081726865069',
            fullFrontendId: 'Smart_Hill/B11/Rack_06',
          },
        ],
      },
      {
        id: '20240335320536014',
        fullFrontendId: 'Smart_Hill/B12',
        packs: [
          {
            id: '49552413449274128',
            fullFrontendId: 'Smart_Hill/B12/Rack_01',
          },
          {
            id: '30191853110409596',
            fullFrontendId: 'Smart_Hill/B12/Rack_02',
          },
          {
            id: '28070762464680969',
            fullFrontendId: 'Smart_Hill/B12/Rack_03',
          },
          {
            id: '69832781860857833',
            fullFrontendId: 'Smart_Hill/B12/Rack_04',
          },
          {
            id: '22891281137356005',
            fullFrontendId: 'Smart_Hill/B12/Rack_05',
          },
          {
            id: '32052106622291805',
            fullFrontendId: 'Smart_Hill/B12/Rack_06',
          },
        ],
      },
      {
        id: '20859898438017379',
        fullFrontendId: 'Smart_Hill/B13',
        packs: [
          {
            id: '38113168415355033',
            fullFrontendId: 'Smart_Hill/B13/Rack_01',
          },
          {
            id: '14302806928450382',
            fullFrontendId: 'Smart_Hill/B13/Rack_02',
          },
          {
            id: '62376281187427261',
            fullFrontendId: 'Smart_Hill/B13/Rack_03',
          },
          {
            id: '17255494565430446',
            fullFrontendId: 'Smart_Hill/B13/Rack_04',
          },
          {
            id: '7023040110786477',
            fullFrontendId: 'Smart_Hill/B13/Rack_05',
          },
          {
            id: '26764239342805376',
            fullFrontendId: 'Smart_Hill/B13/Rack_06',
          },
          {
            id: '30553784399725380',
            fullFrontendId: 'Smart_Hill/B13/Rack_07',
          },
        ],
      },
      {
        id: '7968654005981071',
        fullFrontendId: 'Smart_Hill/B14',
        packs: [
          {
            id: '47066440660800271',
            fullFrontendId: 'Smart_Hill/B14/Rack_01',
          },
          {
            id: '13412229836202362',
            fullFrontendId: 'Smart_Hill/B14/Rack_02',
          },
          {
            id: '3602344568108499',
            fullFrontendId: 'Smart_Hill/B14/Rack_03',
          },
          {
            id: '44577104628557354',
            fullFrontendId: 'Smart_Hill/B14/Rack_04',
          },
          {
            id: '30492556676042766',
            fullFrontendId: 'Smart_Hill/B14/Rack_05',
          },
          {
            id: '70071017920417767',
            fullFrontendId: 'Smart_Hill/B14/Rack_06',
          },
          {
            id: '33143413568738102',
            fullFrontendId: 'Smart_Hill/B14/Rack_07',
          },
        ],
      },
      {
        id: '28520624921613308',
        fullFrontendId: 'Smart_Hill/B15',
        packs: [
          {
            id: '21653856199572797',
            fullFrontendId: 'Smart_Hill/B15/Rack_01',
          },
          {
            id: '27365264825782934',
            fullFrontendId: 'Smart_Hill/B15/Rack_02',
          },
          {
            id: '63557573616345587',
            fullFrontendId: 'Smart_Hill/B15/Rack_03',
          },
          {
            id: '23181206242594511',
            fullFrontendId: 'Smart_Hill/B15/Rack_04',
          },
          {
            id: '62480409727017366',
            fullFrontendId: 'Smart_Hill/B15/Rack_05',
          },
          {
            id: '14158364375943252',
            fullFrontendId: 'Smart_Hill/B15/Rack_06',
          },
          {
            id: '11314509918393158',
            fullFrontendId: 'Smart_Hill/B15/Rack_07',
          },
        ],
      },
      {
        id: '14397688147389146',
        fullFrontendId: 'Smart_Hill/B16',
        packs: [
          {
            id: '17178712120278320',
            fullFrontendId: 'Smart_Hill/B16/Rack_01',
          },
          {
            id: '26682097369265135',
            fullFrontendId: 'Smart_Hill/B16/Rack_02',
          },
          {
            id: '23166424732939833',
            fullFrontendId: 'Smart_Hill/B16/Rack_03',
          },
          {
            id: '52378953485546685',
            fullFrontendId: 'Smart_Hill/B16/Rack_04',
          },
          {
            id: '17927613245815604',
            fullFrontendId: 'Smart_Hill/B16/Rack_05',
          },
          {
            id: '65784297568105507',
            fullFrontendId: 'Smart_Hill/B16/Rack_06',
          },
          {
            id: '8656234036716442',
            fullFrontendId: 'Smart_Hill/B16/Rack_07',
          },
        ],
      },
      {
        id: '4973799425202413',
        fullFrontendId: 'Smart_Hill/B17',
        packs: [
          {
            id: '10110088247115396',
            fullFrontendId: 'Smart_Hill/B17/Rack_01',
          },
          {
            id: '2053692546559302',
            fullFrontendId: 'Smart_Hill/B17/Rack_02',
          },
          {
            id: '70581178585199271',
            fullFrontendId: 'Smart_Hill/B17/Rack_03',
          },
          {
            id: '52500410976540328',
            fullFrontendId: 'Smart_Hill/B17/Rack_04',
          },
          {
            id: '24956673337015736',
            fullFrontendId: 'Smart_Hill/B17/Rack_05',
          },
          {
            id: '35910466305307305',
            fullFrontendId: 'Smart_Hill/B17/Rack_06',
          },
          {
            id: '32300504484497934',
            fullFrontendId: 'Smart_Hill/B17/Rack_07',
          },
        ],
      },
      {
        id: '70720494449034970',
        fullFrontendId: 'Smart_Hill/B18',
        packs: [
          {
            id: '50619950495859730',
            fullFrontendId: 'Smart_Hill/B18/Rack_01',
          },
          {
            id: '38645722419021758',
            fullFrontendId: 'Smart_Hill/B18/Rack_02',
          },
          {
            id: '28862791299318153',
            fullFrontendId: 'Smart_Hill/B18/Rack_03',
          },
          {
            id: '45065540055841262',
            fullFrontendId: 'Smart_Hill/B18/Rack_04',
          },
          {
            id: '38070773761938067',
            fullFrontendId: 'Smart_Hill/B18/Rack_05',
          },
          {
            id: '63722519976061634',
            fullFrontendId: 'Smart_Hill/B18/Rack_06',
          },
          {
            id: '52481637789387812',
            fullFrontendId: 'Smart_Hill/B18/Rack_07',
          },
        ],
      },
      {
        id: '52453168776388276',
        fullFrontendId: 'Smart_Hill/B19',
        packs: [
          {
            id: '48688770396985074',
            fullFrontendId: 'Smart_Hill/B19/Rack_01',
          },
          {
            id: '14460835168906315',
            fullFrontendId: 'Smart_Hill/B19/Rack_02',
          },
          {
            id: '52998696880078229',
            fullFrontendId: 'Smart_Hill/B19/Rack_03',
          },
          {
            id: '31443814677279121',
            fullFrontendId: 'Smart_Hill/B19/Rack_04',
          },
          {
            id: '49265051464892748',
            fullFrontendId: 'Smart_Hill/B19/Rack_05',
          },
          {
            id: '38695840649889281',
            fullFrontendId: 'Smart_Hill/B19/Rack_06',
          },
          {
            id: '1495526027727418',
            fullFrontendId: 'Smart_Hill/B19/Rack_07',
          },
        ],
      },
      {
        id: '65006415899326271',
        fullFrontendId: 'Smart_Hill/B20',
        packs: [
          {
            id: '48971081830872427',
            fullFrontendId: 'Smart_Hill/B20/Rack_01',
          },
          {
            id: '48757661508021137',
            fullFrontendId: 'Smart_Hill/B20/Rack_02',
          },
          {
            id: '4809815686882139',
            fullFrontendId: 'Smart_Hill/B20/Rack_03',
          },
          {
            id: '48860916300418370',
            fullFrontendId: 'Smart_Hill/B20/Rack_04',
          },
          {
            id: '7158730309284118',
            fullFrontendId: 'Smart_Hill/B20/Rack_05',
          },
          {
            id: '45886904170386958',
            fullFrontendId: 'Smart_Hill/B20/Rack_06',
          },
          {
            id: '41779508507157494',
            fullFrontendId: 'Smart_Hill/B20/Rack_07',
          },
        ],
      },
      {
        id: '4671598442638018',
        fullFrontendId: 'Smart_Hill/B21',
        packs: [
          {
            id: '24720327318688765',
            fullFrontendId: 'Smart_Hill/B21/Rack_01',
          },
          {
            id: '8728481069468717',
            fullFrontendId: 'Smart_Hill/B21/Rack_02',
          },
          {
            id: '46464522625092637',
            fullFrontendId: 'Smart_Hill/B21/Rack_03',
          },
          {
            id: '24854970671686656',
            fullFrontendId: 'Smart_Hill/B21/Rack_04',
          },
          {
            id: '21031844976569424',
            fullFrontendId: 'Smart_Hill/B21/Rack_05',
          },
          {
            id: '6423388808866096',
            fullFrontendId: 'Smart_Hill/B21/Rack_06',
          },
        ],
      },
      {
        id: '2612182939287076',
        fullFrontendId: 'Smart_Hill/B22',
        packs: [
          {
            id: '62831424725959684',
            fullFrontendId: 'Smart_Hill/B22/Rack_01',
          },
          {
            id: '56324449473423419',
            fullFrontendId: 'Smart_Hill/B22/Rack_02',
          },
          {
            id: '34327688058749069',
            fullFrontendId: 'Smart_Hill/B22/Rack_03',
          },
          {
            id: '39958433636088164',
            fullFrontendId: 'Smart_Hill/B22/Rack_04',
          },
          {
            id: '64556568985671684',
            fullFrontendId: 'Smart_Hill/B22/Rack_05',
          },
          {
            id: '14406090077838900',
            fullFrontendId: 'Smart_Hill/B22/Rack_06',
          },
        ],
      },
      {
        id: '25931767534931922',
        fullFrontendId: 'Smart_Hill/B23',
        packs: [
          {
            id: '7008414388066132',
            fullFrontendId: 'Smart_Hill/B23/Rack_01',
          },
          {
            id: '33765978306653749',
            fullFrontendId: 'Smart_Hill/B23/Rack_02',
          },
          {
            id: '54736456623951924',
            fullFrontendId: 'Smart_Hill/B23/Rack_03',
          },
          {
            id: '21158550799695844',
            fullFrontendId: 'Smart_Hill/B23/Rack_04',
          },
          {
            id: '43159537906949796',
            fullFrontendId: 'Smart_Hill/B23/Rack_05',
          },
          {
            id: '39633842424073716',
            fullFrontendId: 'Smart_Hill/B23/Rack_06',
          },
        ],
      },
      {
        id: '12521425487257130',
        fullFrontendId: 'Smart_Hill/B24',
        packs: [
          {
            id: '67736055067444724',
            fullFrontendId: 'Smart_Hill/B24/Rack_01',
          },
          {
            id: '64133721774549157',
            fullFrontendId: 'Smart_Hill/B24/Rack_02',
          },
          {
            id: '26746976799459653',
            fullFrontendId: 'Smart_Hill/B24/Rack_03',
          },
          {
            id: '37043901825749220',
            fullFrontendId: 'Smart_Hill/B24/Rack_04',
          },
          {
            id: '25092464966566965',
            fullFrontendId: 'Smart_Hill/B24/Rack_05',
          },
          {
            id: '27418821027610373',
            fullFrontendId: 'Smart_Hill/B24/Rack_06',
          },
        ],
      },
    ],
  },
];
